// ===============================
// pages/Trending.jsx
// ===============================

import React from "react";
import "./Trending.css";

const Trending = () => {
  return (
    <div className="trending-page">

      <div className="page-banner">
        <h1>Trending Products</h1>
      </div>

      <div className="container trending-wrapper">

        <div className="trend-card">
          <img
            src="https://images.unsplash.com/photo-1523275335684-37898b6baf30"
            alt=""
          />

          <h3>Luxury Smart Watch</h3>

          <p>
            Premium trending collection
          </p>
        </div>

        <div className="trend-card">
          <img
            src="https://images.unsplash.com/photo-1505740420928-5e560c06d30e"
            alt=""
          />

          <h3>Wireless Headphones</h3>

          <p>
            Best audio experience
          </p>
        </div>

      </div>

    </div>
  );
};

export default Trending;